import { Component } from '@angular/core';

import { AgRendererComponent } from 'ag-grid-angular';
/*import { ICellRenderer, GridApi } from '@ag-grid-enterprise/all-modules';*/
import { ICellRenderer, GridApi } from 'ag-grid-community';

@Component({
    selector: 'app-switch-renderer',
    templateUrl: './switch-renderer.component.html',
    standalone: false
})
export class SwitchRendererComponent implements AgRendererComponent, ICellRenderer {
    params: any;
    _isVisible: boolean = true;

    api: GridApi;

    get isChecked(): boolean {
        return this.params.data[this.params.field] != null ? this.params.data[this.params.field] : false;
    }

  constructor() {
  }

    agInit(params): void {

        this.params = params;
        this.api = this.params.api;
      //First set _isVisible based on isVisibleField property
      this._isVisible = params.data[params.isVisibleField] != null && params.data[params.isVisibleField] != undefined ? params.data[params.isVisibleField] : true;
      //now check if a method was provided, if so override _isVisible
      if (params.isVisible != null && params.isVisible != undefined)
          this._isVisible = this.params.isVisible(this.params);

        params.eGridCell?.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault();
                this.params.data[this.params.field] = !this.isChecked;
                this.params.action(this.params.data);
            }
        });
    }

    getValue() {
        return this.isChecked;
    }

  refresh(params: any): boolean {
    return true;
  }

    onClick(event: any): void {
        this.params.data[this.params.field] = event.currentTarget.checked;
        this.params.action(this.params.data);       
    }


    onChange(event: any) {

        this.params.data[this.params.field] = event.currentTarget.checked;
    }
}

export type CellAction = (params) => void;